<script setup>
import ModalBox from './ModalBox.vue'
import FormButton from '@/components/Atoms/FormButton.vue'
import { useLegacyModalBridge } from '@/composables/useLegacyModalBridge'

const props = defineProps({
	modalId: {
		type: String,
		default: 'modal-alert',
	},
	okText: {
		type: String,
		default: 'Yes',
	},
	buttonAlignment: {
		type: String,
		default: '',
	},
})

const emit = defineEmits(['modal-confirm'])

const { isVisible, hide } = useLegacyModalBridge(() => props.modalId)

const onConfirm = () => {
	emit('modal-confirm')
	hide()
}

const dismiss = () => {
	hide()
}
</script>

<template>
	<ModalBox
		v-model="isVisible"
		size="sm"
		hide-close
		header-class="!hidden"
		wrapper-classes="lg:h-auto lg:max-h-none"
	>
		<div class="px-6 pt-6 text-surface-text-2">
			This file doesn't match our recommended settings
		</div>
		<div class="px-6 pt-2 text-surface-7 text-sm">
			Playback may be unstable. For best results, re-encode it using our
			<a target="_blank" class="text-reset text-underline" href="https://docs.castr.com/en/articles/5161326-recommended-settings-for-recorded-videos">recommended settings</a>.
			If you'd rather use it as-is, run a quick test stream first.
		</div>
		<template #footer>
			<div :class="[buttonAlignment, 'flex justify-end gap-2 p-6']">
				<FormButton type="secondary" size="md" @click="dismiss">
					Cancel
				</FormButton>
				<FormButton type="main" size="md" @click="onConfirm">
					{{ okText }}
				</FormButton>
			</div>
		</template>
	</ModalBox>
</template>
